export const initialFloorState = {
  thickness: 15,
  drainages: []
}

